<template>
  <!-- 问题看板 2D 3D 文件 -->
  <div class="questionBoard">
    <!-- 标签行 -->
    <div class="labels">
      <el-tag type="info" effect="plain">
        <img :src="dataBoard1" />
        <div class="tag_text">
          <div class="text_up">{{ totalNum }}例</div>
          <div class="text_down">问题总数</div>
        </div>
      </el-tag>
      <el-tag type="info" effect="plain">
        <img :src="dataBoard2" />
        <div class="tag_text" effect="plain">
          <div class="text_up">{{ modificationRate }}</div>
          <div class="text_down">问题修改率</div>
        </div>
      </el-tag>
      <el-tag type="info" effect="plain">
        <img :src="dataBoard3" />
        <div class="tag_text">
          <div class="text_up">{{ reviewRate }}</div>
          <div class="text_down">问题复核率</div>
        </div>
      </el-tag>
      <el-tag type="info" effect="plain">
        <img :src="dataBoard4" />
        <div class="tag_text">
          <div class="text_up">{{ internalPeopleNum }}人</div>
          <div class="text_down">内部参与人数</div>
        </div>
      </el-tag>
      <el-tag type="info" effect="plain">
        <img :src="dataBoard5" />
        <div class="tag_text">
          <div class="text_up">{{ externalPeopleNum }}人</div>
          <div class="text_down">外部参与人数</div>
        </div>
      </el-tag>
    </div>

    <!-- 问题分布统计 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>问题分布统计</span>
      </div>
      <div class="title_right">
        <span>所属部门：</span>
        <el-cascader v-model="queScatter_department" :options="departments" size="small" clearable placeholder="全部"
          :props="{value: 'deptId', label: 'deptName', children: 'children', checkStrictly: true}"
          @change="queScatter_setOption">
        </el-cascader>
      </div>
    </div>
    <div class="queScatter_board">
      <!-- 问题专业分布图 -->
      <div ref="specChart" class="queScatter_slider"></div>
      <!-- 问题类型分布图 -->
      <div ref="typeChart" class="queScatter_slider"></div>
      <!-- 问题严重等级图 -->
      <div ref="severityChart" class="queScatter_slider"></div>
      <!-- 问题状态分布图 -->
      <div ref="statusChart" class="queScatter_slider"></div>
    </div>

    <!-- 人员问题数统计 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>人员问题数统计</span>
      </div>
      <div class="title_right">
        <span>统计维度：</span>
        <el-cascader v-model="census_dimension" :options="dimensions" size="small" clearable placeholder="全部"
          :props="{value: 'cnName', label: 'cnName', children: 'childNode' }" @change="census_setOption">
        </el-cascader>

        <span>统计时间段：</span>
        <el-date-picker v-model="census_date" :picker-options="pickerOptions" type="monthrange" size="small"
          align="right" start-placeholder="开始月份" range-separator="至" end-placeholder="结束月份" unlink-panels
          @change="census_setOption">
        </el-date-picker>

        <span>所属部门：</span>
        <el-cascader v-model="census_department" :options="departments" size="small" clearable placeholder="全部"
          :props="{value: 'deptId', label: 'deptName', children: 'children', checkStrictly: true}"
          @change="census_setOption">
        </el-cascader>
      </div>
    </div>
    <div class="census_board">
      <!-- 人员问题数统计图 -->
      <div ref="census" class="census_slider"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { mapState } from "vuex";
import dataBoardService from "@/CommonDP/service/dataBoard-service.js";
import { storage } from "@/CommonDP/utils";
import moment from "moment";

var specChart; // 问题专业分布图
var typeChart; // 问题类型分布图
var severityChart; // 问题严重等级图
var statusChart; // 问题状态分布图

var censusChart; // 人员问题数统计图

export default {
  components: {},
  props: ["questionType"],
  data() {
    return {
      // 标签行
      totalNum: 0, //	项目总问题数
      modificationRate: "0%", //	问题处理率
      reviewRate: "0%", //	问题复核率
      internalPeopleNum: 0, //		内部参与人数
      externalPeopleNum: 0, //	外部参与人数

      dataBoard1: require("@/CommonDP/assets/projectMg/dataBoard/dataBoard1.png"), // 图标
      dataBoard2: require("@/CommonDP/assets/projectMg/dataBoard/dataBoard2.png"),
      dataBoard3: require("@/CommonDP/assets/projectMg/dataBoard/dataBoard3.png"),
      dataBoard4: require("@/CommonDP/assets/projectMg/dataBoard/dataBoard4.png"),
      dataBoard5: require("@/CommonDP/assets/projectMg/dataBoard/dataBoard5.png"),

      departments: [], // 部门
      dimensions: [], // 维度

      queScatter_department: [], // 问题分布统计,选择所属部门
      specDistribution: [], // 	问题专业分布
      typeDistribution: [], // 	问题类型分布
      severityLevelDistribution: [], // 问题严重等级
      statusDistribution: [], // 	问题状态分布

      census_dimension: ["设计"], // 人员问题数统计,选择统计维度
      census_department: [], // 人员问题数统计,选择所属部门
      census_date: [new Date(), new Date()], // 人员问题数统计，绑定时间
      censusData: [], // 人员问题数统计数据

      pickerOptions: {
        // 日期选择快捷键
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            }
          },
          {
            text: "年初至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    prjId() {
      return storage.get("updatePrjcook");
    },
    // 开始时间
    startDate() {
      if (this.census_date && this.census_date.length > 0) {
        return moment(this.census_date[0]).format("YYYY-MM");
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.census_date && this.census_date.length > 1) {
        return moment(this.census_date[1]).format("YYYY-MM");
      } else {
        return "";
      }
    }
  },
  watch: {
    questionType() {
      this.getLabelsData();
      this.queScatter_setOption();
      this.census_setOption();
    }
  },
  mounted() {
    this.getDepartmentsAndDimensions();
    this.getLabelsData();
    this.queScatter_init();
    this.census_init();
  },
  methods: {
    // 获得部门和维度的数据
    async getDepartmentsAndDimensions() {
      const res1 = await dataBoardService.getDepartments(this.enterpriseId);
      this.departments = this.getTreeData(res1.data);
      const res2 = await dataBoardService.getDimensions();
      this.dimensions = res2.data;
    },

    // 递归判断列表，把最后的children设为undefined
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },

    // 获得标签行数据
    async getLabelsData() {
      const params = {
        prjId: this.prjId,
        category: this.questionType // 问题类型
      };
      const res = await dataBoardService.getLabelsData(params);
      this.totalNum = res.data.totalNum;
      this.modificationRate = res.data.modificationRate;
      this.reviewRate = res.data.reviewRate;
      this.internalPeopleNum = res.data.internalPeopleNum;
      this.externalPeopleNum = res.data.externalPeopleNum;
    },

    // 获得问题分布统计数据
    async getQueScatterData() {
      const params = {
        prjId: this.prjId,
        deptId: this.queScatter_department[this.queScatter_department.length - 1], // 部门id
        category: this.questionType // 问题类型
      };
      const res = await dataBoardService.getQueScatterData(params);
      this.specDistribution = res.data.specDistribution;
      this.typeDistribution = res.data.typeDistribution;
      this.severityLevelDistribution = res.data.severityLevelDistribution;
      this.statusDistribution = res.data.statusDistribution;
    },

    // 问题分布统计_初始化
    queScatter_init() {
      specChart = echarts.init(this.$refs.specChart); // 问题专业分布图
      typeChart = echarts.init(this.$refs.typeChart); // 问题类型分布图
      severityChart = echarts.init(this.$refs.severityChart); // 问题严重等级图
      statusChart = echarts.init(this.$refs.statusChart); // 问题状态分布图
      this.queScatter_setOption();
    },

    // 问题分布统计_加载数据
    queScatter_setOption() {
      this.getQueScatterData().then(() => {
        let title = "";
        let legendData = [];
        let seriesData = [];
        const option = {
          title: {
            text: "",
            top: "45.5%",
            left: "18%",
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              fontWeight: "bold",
              color: "#666666"
            }
          },
          // 图例
          legend: {
            type: "scroll",
            orient: "vertical", // 垂直布局
            left: "67%",
            y: "center",
            data: []
          },
          // 列表
          series: [
            {
              type: "pie",
              radius: ["58%", "78%"],
              center: ["34%", "50%"],
              label: {
                show: false
              },
              data: []
            }
          ],
          // 提示
          tooltip: {
            trigger: "item",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [10, 30, 10, 10],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px", // 行高
            formatter(e) {
              return e.marker + " " + e.name + "<br>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + "问题数：" + e.value + "<br>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + "占比：" + e.percent + "%";
            }
          }
        };

        title = "问题专业分布";
        const specList = this.specDistribution.filter((item) => item.num !== 0);
        legendData = specList.map((item) => item.name);
        seriesData = specList.map((item) => {
          return { name: item.name, value: item.num };
        });
        option.title.text = title;
        option.legend.data = legendData;
        option.series[0].data = seriesData;
        specChart.setOption(option, true);

        title = "问题类型分布";
        const typeList = this.typeDistribution.filter((item) => item.num !== 0);
        legendData = typeList.map((item) => item.name);
        seriesData = typeList.map((item) => {
          return { name: item.name, value: item.num };
        });
        option.title.text = title;
        option.legend.data = legendData;
        option.series[0].data = seriesData;
        typeChart.setOption(option, true);

        title = "问题严重等级";
        const severityList = this.severityLevelDistribution.filter((item) => item.num !== 0);
        legendData = severityList.map((item) => item.name);
        seriesData = severityList.map((item) => {
          return { name: item.name, value: item.num };
        });
        option.title.text = title;
        option.legend.data = legendData;
        option.series[0].data = seriesData;
        severityChart.setOption(option, true);

        title = "问题状态分布";
        const statusList = this.statusDistribution.filter((item) => item.num !== 0);
        legendData = statusList.map((item) => item.name);
        seriesData = statusList.map((item) => {
          return { name: item.name, value: item.num };
        });
        option.title.text = title;
        option.legend.data = legendData;
        option.series[0].data = seriesData;
        statusChart.setOption(option, true);
      });
    },

    // 获得人员问题数统计数据
    async getCensusData() {
      const params = {
        prjId: this.prjId,
        deptId: this.census_department[this.census_department.length - 1], // 部门id
        category: this.questionType, // 问题类型
        startDate: this.startDate, // 开始时间
        endDate: this.endDate // 结束时间
      };
      const res = await dataBoardService.getCensusData(params);
      this.censusData = res.data;
    },

    // 人员问题数统计_初始化
    census_init() {
      censusChart = echarts.init(this.$refs.census);
      this.census_setOption();
    },

    // 人员问题数统计_加载数据
    census_setOption() {
      this.getCensusData().then(() => {
        let legend = [];
        let x_users = [];
        let x_roles = [];
        let createNum = [];
        let pendingNum = [];
        let modifiedNum = [];
        let reviewedNum = [];
        const option = {
          // 图例
          legend: {
            orient: "horizontal", // 水平布局
            bottom: "0%",
            x: "center",
            itemGap: 50, // 间隔
            data: []
          },
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: [],
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464" }, // 标签
              axisTick: {
                show: false
              } // 刻度
            },
            {
              type: "category",
              data: [],
              position: "bottom",
              offset: 30,
              axisLine: { show: false }, // 轴线
              axisLabel: { color: "#646464" }, // 标签
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "5%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 9,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "",
              type: "bar",
              barWidth: 25, // 柱图宽度
              data: []
            },
            {
              name: "",
              type: "bar",
              barWidth: 25, // 柱图宽度
              data: []
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };

        x_users = this.censusData.map((item) => item.name);
        x_roles = this.censusData.map((item) => item.roleList[0].roleName);
        createNum = this.censusData.map((item) => item.createNum); // 创建问题数
        pendingNum = this.censusData.map((item) => item.pendingNum); // 待修改问题数
        modifiedNum = this.censusData.map((item) => item.modifiedNum); // 已修改问题数
        reviewedNum = this.censusData.map((item) => item.reviewedNum); // 已复核问题数
        if (this.census_dimension[0] === "设计") {
          legend = ["已修改问题数", "待修改问题数"];
          option.legend.data = legend;
          for (let index = 0; index < x_users.length; index++) {
            if (modifiedNum[index] === 0 && pendingNum[index] === 0) {
              modifiedNum.splice(index, 1);
              pendingNum.splice(index, 1);
              x_users.splice(index, 1);
              x_roles.splice(index, 1);
              index--;
            }
          }
          option.series[0].data = modifiedNum;
          option.series[0].name = "已修改问题数";
          option.series[1].data = pendingNum;
          option.series[1].name = "待修改问题数";
        } else {
          legend = ["创建问题数", "已复核问题数"];
          option.legend.data = legend;
          for (let index = 0; index < x_users.length; index++) {
            if (createNum[index] === 0 && reviewedNum[index] === 0) {
              createNum.splice(index, 1);
              reviewedNum.splice(index, 1);
              x_users.splice(index, 1);
              x_roles.splice(index, 1);
              index--;
            }
          }
          option.series[0].data = createNum;
          option.series[0].name = "创建问题数";
          option.series[1].data = reviewedNum;
          option.series[1].name = "已复核问题数";
        }
        option.xAxis[0].data = x_users;
        option.xAxis[1].data = x_roles;
        if (x_users.length < 11) option.dataZoom = [];
        censusChart.setOption(option, true);
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.questionBoard {
  width: 100%;
  .labels {
    width: 100%;
    padding: var(--big-space);
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);
    display: flex;
    align-items: center;

    .el-tag {
      width: 235px;
      height: max-content;
      padding: 28px 1%;
      border: 1px solid #d5deef;
      border-radius: 4px;
      margin-right: var(--big-space);
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        width: 52px;
        height: 52px;
        margin: 0 4%;
      }

      .tag_text {
        width: 1px;
        flex-grow: 2;

        .text_up {
          font-size: 24px;
          font-weight: 700;
          color: var(--key-color);
          white-space: nowrap;
        }

        .text_down {
          font-size: 14px;
          color: var(--key-color);
          white-space: pre-wrap;
        }
      }
    }
  }

  .queScatter_board {
    width: 100%;
    padding: 30px 10px 60px;
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);
    display: flex;
    justify-content: space-around;
    align-items: center;

    .queScatter_slider {
      width: 280px;
      height: 220px;
    }
  }

  .census_board {
    width: 100%;
    padding: 40px 4% 40px;
    border-radius: 0 0 4px 4px;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;

    .census_slider {
      width: 1440px;
      height: 360px;
    }
  }
}

.title {
  width: 100%;
  padding: var(--small-space) var(--big-space);
  border-bottom: 1px solid #e6eaf8;
  border-radius: 4px 4px 0 0;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title_left {
    display: flex;
    align-items: center;

    .el-divider {
      background-color: var(--theme-color);
      width: 3px;
      height: 15px;
      margin: 0 8px 0 0;
    }

    span {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      color: var(--key-color);
      white-space: nowrap;
    }
  }

  .title_right {
    display: flex;
    align-items: center;

    span {
      font-family: "Microsoft YaHei UI";
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: var(--common-color);
      white-space: nowrap;
      padding-left: 25px;
    }
  }
}

/deep/.el-range-separator {
  width: max-content;
}
</style>
